module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JKzL3B/tc-custom/9781460386545.jpg?1705025876050",
      "alt": "This image is the cover for the book Brazilian's Nine Months' Notice"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brazilian's Nine Months' Notice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the "), _c('i', [_vm._v("USA Today–")]), _vm._v("bestselling author’s international romance, a wealthy Brazilian will do anything to claim the spirited beauty who carries his heir.")]), _c('br'), _c('br'), _vm._v("For chambermaid Emma Fane, her best friend’s winter wedding promises to be the perfect distraction for her troubles. Until, heart racing, she spies Lucas Marcelos—infamous lothario and father to her unborn child!"), _c('br'), _c('br'), _vm._v("Lucas may have lost his head over innocent, spirited Emma for one glorious night, but he won’t lose his heir! He lures her away from snowy Scotland back to sultry Brazil. But Emma is no man’s mistress. It only took one night to change their lives, now they have nine months to face the consequences . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Stephens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Stephens is passionate about writing books set in fabulous locations where an outstanding man comes to grips with a cool, feisty woman. Susan’s hobbies include travel, reading, theatre, long walks, playing the piano, and she loves hearing from readers at her website. "), _c('a', {
    attrs: {
      "href": "http://www.susanstephens.com"
    }
  }, [_vm._v("www.susanstephens.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0